import { render } from "./CxAwarenessEventDetailsPanel.vue?vue&type=template&id=172dad7c"
import script from "./CxAwarenessEventDetailsPanel.vue?vue&type=script&lang=js"
export * from "./CxAwarenessEventDetailsPanel.vue?vue&type=script&lang=js"

import "./CxAwarenessEventDetailsPanel.vue?vue&type=style&index=0&id=172dad7c&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__